import { useTranslation } from 'react-i18next';
import FaceUniquenessStep from '../../providers/validation/steps/FaceUniquenessStep';
import GenericFaceAuthScreen from './GenericFaceAuthScreen';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import { useContext } from 'react';
import { Routes } from '../../config/routes';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';
import { Action } from '../../config';

function FaceUniquenessScreen(): JSX.Element {
  const { t } = useTranslation();
  const { action, credentialExpired } = useContext(FlowConfigContext);
  const flowAction = credentialExpired && action === Action.REFRESH ? Action.ISSUANCE : action;
  const stepWorker = (userDid: string) => new FaceUniquenessStep(userDid, flowAction);

  return (
    <GenericFaceAuthScreen
      route={Routes.FACE_UNIQUENESS}
      getStepWorker={stepWorker}
      description={{
        text: t('screens.chooseWebOrMobile.descriptionUniqueness'),
        link: 'https://support.civic.com/hc/en-us/articles/12215458152343-How-do-I-delete-my-Civic-Uniqueness-Pass-',
      }}
    />
  );
}
export default withRouteAnalytics(FaceUniquenessScreen, Screens.FACE_UNIQUENESS);
